import type { IconProps } from './types';

export const Copy01Icon = (props: IconProps) => {
  const { color = 'currentColor', size = 24, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...other}
      ref={ref}
    >
      <path d="M17.625 2.625H2.625V17.625" stroke={color} strokeWidth="1.5" />
      <path d="M21.375 6.375H6.375V21.375H21.375V6.375Z" stroke={color} strokeWidth="1.5" />
    </svg>
  );
};
